import { trackEvent } from "../utils/track-event";
import type { TrackingEvent, TrackingEventResponse } from "../utils/types";

export type CoframeExperimentAssignedProps = {
  coframe_experiment_id: string;
  coframe_experiment_slug: string;
  coframe_variant_id: string;
  coframe_variant_slug: string;
  coframe_user_token: string;
  coframe_impression_id: string;
  coframe_in_global_holdout: boolean;
  coframe_in_exp_baseline: boolean;
  shop_type?: string;
};

export type CoframeExperimentAssignedEvent = TrackingEvent<
  "Coframe Experiment Assigned",
  CoframeExperimentAssignedProps
>;

export async function trackCoframeExperimentAssigned(
  props: CoframeExperimentAssignedProps
): TrackingEventResponse {
  return await trackEvent("Coframe Experiment Assigned", { props });
}
